import React, { useState, useEffect } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreForm from '../../../components/forms/ScoreForm';
import { useScoreApi } from '../../../hooks/useScoreApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScoreDTO } from '../../../services/apiClient';

const ScoreCreate: React.FC = () => {
  const { create, isLoading } = useScoreApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<ScoreDTO>({} as ScoreDTO);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    const firearmId = searchParams.get('firearm');
    if (firearmId) {
      setInitialValues({ memberFirearmId: firearmId } as ScoreDTO);
    }
    setIsInitialized(true);
  }, [searchParams]);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Scores', href: '/admin/scores' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ScoreDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Score:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scores"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.Score.Edit'
    >
      {isInitialized && (
        <ScoreForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      )}
    </AdminLayout>
  );
};

export default ScoreCreate;